import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../../../lib/utils';

const colorVariants = cva('text-primary', {
  variants: {
    variant: {
      foreground: 'text-foreground',
      muted: 'text-muted-foreground',
      primary: 'text-primary',
      secondary: 'text-secondary',
      accent: 'text-accent',
      destructive: 'text-destructive',
      teal: 'text-primary',
    },
  },
  defaultVariants: {
    variant: 'teal',
  },
});

export interface TimelineDotProps
  extends React.SVGProps<SVGSVGElement>, VariantProps<typeof colorVariants> {
  size?: number | string;
}

export const TimelineDot = React.forwardRef<SVGSVGElement, TimelineDotProps>(
  function TimelineDot(
    { className, style, size, width, height, variant, ...rest },
    ref,
  ) {
    const computedWidth = width ?? size ?? 20;
    const computedHeight = height ?? size ?? 21;
    const colorClass = colorVariants({ variant });

    return (
      <svg
        ref={ref}
        className={cn('stroke-current', colorClass, className)}
        style={{ ...(style as React.CSSProperties) }}
        width={computedWidth}
        height={computedHeight}
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <circle
          cx="10"
          cy="10.3799"
          r="9.20771"
          transform="rotate(-180 10 10.3799)"
          fill="currentColor"
          fillOpacity="0.1"
          stroke="currentColor"
          strokeWidth="1.58458"
        />
      </svg>
    );
  },
);

TimelineDot.displayName = 'TimelineDot';
